const getTopDownloadPdfButton = require("./getTopDownloadPdfButton");

/**
 * @param roiCalculatorDocument {Document}
 * @param onClicked {() => void}
 * @return {void}
 */
module.exports = function listenToRoiCalculatorTopDownloadPdfButtonClick(roiCalculatorDocument, onClicked) {
    const button = getTopDownloadPdfButton(roiCalculatorDocument);

    if (button) {
        button.addEventListener("click", () => {
            onClicked();
        });
    }
}
